import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

/**
 * Moves focus to the host element once it is inserted — e.g. a dialog's primary action when the dialog
 * opens — so keyboard and screen-reader users land inside the dialog rather than being left on the page
 * behind it.
 */
@Directive({
  selector: '[appAutofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  ngAfterViewInit(): void {
    this.host.nativeElement.focus();
  }
}
